<template>
	<div>
		<div class="page-bg">
			<!-- <div class="flex1 f-pr">

				<div class="file-list">
					<div v-for="file in files" :key="file.id" class="file-item" @click="downloadFile(file)">
						<h3>{{ file.name }}</h3>
						<h3 v-if="file.type === 'pdf'">[PDF]</h3>
						<h3 v-else-if="file.type === 'word'">[Word]</h3>
					</div>
					<div v-if="showTip" class="tip">
						苹果微信浏览器暂不支持直接下载，请点击右上角用浏览器打开后下载。
					</div>
				</div>
			</div> -->
			<div class="points-ranking-page">
				<div class="logo">
					<img src="../assets/logo.png" alt="" />
				</div>	
				<div class="title-bar fcc" style="margin-bottom: 56px;">
					<img src="../assets/slogen-page.png" alt="" />
				</div>
				<div class="points-ranking-list-v2" v-for="file in files" :key="file.id" @click="downloadFile(file)">
					<div class="th">
						<div class="col1" style="width: 100%; text-align: left; padding: 10px;">{{ file.name }}</div>
					</div>
				</div>
			</div>
			<div>
				<i-nav></i-nav>
			</div>
		</div>

	</div>
</template>

<script>


export default {

	data() {
		return {
			uid: null,
			files: [
				// 示例数据
				// { id: 1, name: '2025届善建者集训营会议指南.pdf', url: 'https://cscec.warnny.com/api/file/2025届善建者集训营会议指南.pdf', type: 'pdf' },
				// { id: 2, name: '从校园到职场角色转型 学员版.pdf', url: 'https://cscec.warnny.com/api/file/从校园到职场角色转型 学员版.pdf', type: 'pdf' },
				// { id: 3, name: '中建四局即刻向未来新人成长营-学员讲义.pdf', url: 'https://cscec.warnny.com/api/file/中建四局即刻向未来新人成长营-学员讲义.pdf', type: 'pdf' },
				// { id: 4, name: '文件4.docx', url: 'https://cscec.warnny.com/api/file/file2.docx', type: 'word' },
			],
			showTip: false,
		};
	},
	async mounted() {
		this.uid = window.localStorage.getItem('cscec2026UserId')
		if (!this.uid) {
			this.$router.push({ path: '/' })
			return
		}
		if (this.isIOSWeChat()) {
			this.showTip = true;
		}

	},
	methods: {
		isIOSWeChat() {
			const ua = window.navigator.userAgent;
			return /MicroMessenger/i.test(ua) && /\(i[^;]+;( U;)? CPU.+Mac OS X/.test(ua);
		},
		downloadFile(file) {
			console.log("click downloadFile")
			if (this.isIOSWeChat()) {
				window.location.href = file.url;
			} else {
				window.location.href = file.url;
				// 安卓微信支持 download 属性
				// const a = document.createElement('a');
				// a.href = file.url;
				// a.download = file.name;
				// document.body.appendChild(a);
				// a.click();
				// document.body.removeChild(a);
			}
		},
	},
};
</script>
<style scoped lang="less">
.page-bg-album {

	position: absolute;
	width: 100%;
	left: 0;
	top: 0;
	bottom: 0;
	z-index: 1;
	display: flex;
	flex-direction: column;
	// position: absolute;
	// bottom: 170px;
	// width: 100%;
	// top: 146px;
	// overflow: hidden;
	// overflow-y: auto;

	.flex1 {
		flex: 1
	}

	.f-pr {
		position: relative;
	}

	img {
		display: block;
		width: 100%;
	}
}

.file-list {
	padding: 16px;
}

.file-item {
	margin-bottom: 12px;
	cursor: pointer;
	color: #007aff;
}

.tip {
	margin-top: 20px;
	color: #ff4d4f;
	font-size: 14px;
}
</style>
